import { createContext } from 'react';

const ClientFilterContext = createContext();

export default ClientFilterContext;
